import { FORBIDDEN_FAILED_STATUS } from '../constants/auth';

export const isPreTokenGenerationForbiddenError = (
  errorMsg: string
): boolean => {
  return errorMsg
    .replaceAll(/V[123]_0/gi, '')
    .includes(FORBIDDEN_FAILED_STATUS);
};
